export default "__VITE_ASSET__DsSuw5N1__"